import React, { useContext } from 'react';
import styles from '../css/share/share-message.module.css';
import { ShareLinkContext } from './ShareLinkContext';

const textBoxColorMap = {
    morning: { bgColor: '#a1c0f6', textColor: 'black' },
    afternoon: { bgColor: '#fde7a3', textColor: 'black' },
    evening: { bgColor: '#a1c0f6', textColor: 'black' },
    night: { bgColor: '#b3dde8', textColor: 'black' },
};

function ShareMessage({ shareType, timeOfDay, onNext }) {
    const { shareMessage, setShareMessage } = useContext(ShareLinkContext);

    const handleTextInput = (e) => {
        e.stopPropagation();
        setShareMessage(e.target.value);
    }

    const noteStyle = timeOfDay ? { backgroundColor: textBoxColorMap[timeOfDay].bgColor } : {};

    return (
        <div className={styles.shareMessageContainer} onClick={(e) => e.stopPropagation()}>
            <div className={styles.titleContainer}>
                <h3 className={styles.shareMessageTitle}>Add a note about why you're sharing</h3>
            </div>
            <textarea
                placeholder='Help them meet you where you are...'
                className={`${styles.shareMessageTextarea} ${timeOfDay === 'afternoon' ? styles.shareMessageTextareaDark : ''}`}
                style={noteStyle}
                onChange={handleTextInput}
                value={shareMessage}
            />
            <div className={styles.nextButtonContainer}>
                <button className={styles.nextButton} onClick={onNext}>
                    Next
                </button>
            </div>
        </div>
    )
}

export default ShareMessage